<template></template>

<script>
import { mapGetters } from 'vuex'
import { DEVICE_TYPE } from '../assets/js/resource-types'

export default {
  data: function () {
    return {
      device_types_selected_ids: [],
      device_sip_types_selected_ids: [],
      device_subtypes_selected_ids: [],
      device_query_text: ''
    }
  },
  computed: {
    ...mapGetters({
      devices: 'allDevices',
      device_types: 'allDeviceTypes',
      device_sip_types: 'allDeviceSipTypes',
      intercom_external_sips: 'allIntercomExternalSips',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      feature_sip_enabled: 'featureSipEnabled',
      feature_rtp_enabled: 'featureRtpEnabled',
      feature_barionet_enabled: 'featureBarionetEnabled',
      feature_voip_enabled: 'featureVoipEnabled',
      scoped_site_id: 'scopedSiteId',
    }),
    filtered_devices: function () {
      return this.devices.filter((device) => {
        if (device.site_id !== this.scoped_site_id) {
          return false
        }

        if (device.device_type_id === DEVICE_TYPE.Multicast) {
          return false
        }

        if (this.device_types_selected_ids.length === 0) {
          return true
        }

        if (!this.device_types_selected_ids.includes(device.device_type_id)) {
          return false
        }

        if(device.device_subtype_id && this.device_subtypes_selected_ids.length == 0) {
          return true
        }

        if(device.device_subtype_id && !this.device_subtypes_selected_ids.includes(device.device_subtype_id)) {
          return false
        }

        if (device.device_type_id !== DEVICE_TYPE.SIP || this.device_sip_types_selected_ids.length === 0) {
          return true
        }

        if (!this.device_sip_types_selected_ids.includes(device.device_sip_type_id)) {
          return false
        }

        return true
      }).filter(device => this.queried_device_ids.includes(device.device_id))
    },
    filtered_device_types: function () {
      // Multicast (3) and Haven Lock (7) is not included when adding a device.
      let toExcludeIds = [DEVICE_TYPE.Multicast, DEVICE_TYPE.HAVEN]

      if (!this.feature_visual_alert_enabled) {
          toExcludeIds.push(DEVICE_TYPE.Visual)
      }
      if (!this.feature_sip_enabled) {
          toExcludeIds.push(DEVICE_TYPE.SIP)
      }
      if (!this.feature_rtp_enabled) {
          toExcludeIds.push(DEVICE_TYPE.RTP)
      }
      if (!this.feature_barionet_enabled) {
          toExcludeIds.push(DEVICE_TYPE.Barionet)
      }

      return this.device_types.filter(
          dt => !toExcludeIds.includes(dt.device_type_id)
      )
    },
    queried_device_ids() {
      const query_text = this.device_query_text.trim().toLowerCase();
      
      if(query_text === '') return this.devices.map(device => device.device_id);

      return this.devices.filter(device =>(
        device.name.toLowerCase().includes(query_text)
        || device.ip.toLowerCase().includes(query_text)
        ||(device.extension && device.extension.toString().toLowerCase().includes(query_text))
      )).map(device => device.device_id);
    },
    device_subtypes_for_dropdown() {
      const selected_device_types = this.filtered_device_types.filter(dt => this.device_types_selected_ids.includes(dt.device_type_id))
      const available_subtypes = []
      selected_device_types.forEach(dt => {
        for(let subtype of dt.subtypes) {
          available_subtypes.push({
            label: subtype.name,
            value: subtype.device_subtype_id
          })
        }
      })
      const available_subtype_ids = available_subtypes.map(st => st.value)
      this.device_subtypes_selected_ids = this.device_subtypes_selected_ids.filter(id =>  available_subtype_ids.includes(id))
      return available_subtypes
    },
    device_registered_count() {
      return this.filtered_devices.filter(
        (device) => device.registered === true
      ).length
    },
    device_online_count() {
        return this.filtered_devices.filter(
        (device) => device.online === true
      ).length
    },
    device_sip_total() {
      return this.filtered_devices.filter(
        (device) => device.device_type_id === DEVICE_TYPE.SIP
          || device.device_type_id === DEVICE_TYPE.G2Link
          || device.device_type_id === DEVICE_TYPE.G2IPSpeaker
      ).length
    },
    device_total() {
      return this.filtered_devices.length
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getDeviceTypes')
    this.$store.dispatch('getDeviceSipTypes')
    this.$store.dispatch('getIntercomExternalSips')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  methods: {
    refreshDevices () {
      this.$store.dispatch('getDevices')
    },
    sortDevices(sortBy) {
      this.$store.dispatch('sortDevices', sortBy)
    }
  }
}
</script>